<template>
  <v-row justify="center">
    <v-dialog
      v-model="open"
      width="872px"
      :fullscreen="isMobileBreakpoint"
      @click:outside="handleClose"
    >
      <v-card
        class="d-flex flex-column justify-space-between align-center pa-6"
        flat
        tile
        :height="!isMobileBreakpoint ? 637 : ''"
      >
        <div class="w-full d-flex justify-end">
          <v-btn icon @click="handleClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="container-title mb-8">
          <h1 class="body-bold-xlarge mt-2">
            {{ $t('message.pages.funnel.addVideo.title') }}
          </h1>
          <span class="body-regular-base neutral-40-light--text">{{
            $t('message.pages.funnel.addVideo.description')
          }}</span>
        </div>
        <div
          style="
            display: flex;
            gap: 24px;
            margin-bottom: 80px;
            margin-top: 60px;
            height: 380px;
          "
          :class="{ 'flex-column': isMobileBreakpoint }"
        >
          <div
            class="container-card-options"
            :class="{ 'w-full': isMobileBreakpoint }"
          >
            <svg
              class="mr-2"
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.1043 9.68963L20.0437 7.63352L22.9403 11.3711L16.0362 13.3781L13.1043 9.68963ZM5.15441 8.56859L19.7681 4.23862C20.0173 4.08813 20.294 4.00999 20.5709 4.00074L27.6544 1.90193L27.6894 1.89198C30.3296 1.17191 33.1085 2.59134 33.8892 5.18177L33.8909 5.18768L35.2209 9.50978C35.3522 9.93657 35.3068 10.3982 35.0948 10.7912C34.8828 11.1842 34.5219 11.4757 34.0931 11.6003L26.6493 13.7643C26.398 13.9147 26.1192 13.9919 25.8405 13.9994L16.6653 16.6666H34.9612C35.8817 16.6666 36.6279 17.4128 36.6279 18.3332V31.6666C36.6279 32.9927 36.1011 34.2644 35.1634 35.2021C34.2257 36.1398 32.954 36.6666 31.6279 36.6666H8.29454C6.96845 36.6666 5.69668 36.1398 4.759 35.2021C3.82132 34.2644 3.29454 32.9927 3.29454 31.6666V18.6354L1.90068 14.9185C1.88263 14.8703 1.86681 14.8214 1.85329 14.7718C1.13267 12.1295 2.55481 9.34847 5.14898 8.57021L5.15441 8.56858L5.15441 8.56859ZM26.3821 10.3706L23.4734 6.61733L28.5814 5.10382C29.5995 4.83414 30.4775 5.40996 30.6982 6.1455L30.6981 6.14552L30.7016 6.15673L31.5371 8.87206L26.3821 10.3706ZM9.65794 10.7108L6.10681 11.763L6.10465 11.7636C5.38196 11.9818 4.81424 12.8346 5.05277 13.8307L5.97937 16.3016L12.5774 14.3836L9.65794 10.7108ZM6.62787 31.6666V19.9999H33.2945V31.6666C33.2945 32.1086 33.1189 32.5325 32.8064 32.8451C32.4938 33.1576 32.0699 33.3332 31.6279 33.3332H8.29454C7.85251 33.3332 7.42859 33.1576 7.11603 32.8451C6.80347 32.5325 6.62787 32.1086 6.62787 31.6666Z"
                fill="#3F55EE"
              />
            </svg>
            <h1 class="body-bold-base mt-1">
              {{ $t('message.pages.funnel.addVideo.chooseFromFunnel') }}
            </h1>
            <span class="body-regular-small neutral-40-light--text text-center">
              {{ $t('message.pages.funnel.addVideo.chooseExistingVideo') }}
            </span>

            <base-btn class="mt-4" @click="selectedLibraryFromFolder">
              {{ $t('message.pages.funnel.addVideo.select') }}</base-btn
            >
          </div>
          <div
            class="container-card-options"
            :class="{ 'w-full': isMobileBreakpoint }"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M18.8214 3.82141C19.4723 3.17053 20.5276 3.17053 21.1785 3.82141L31.1785 13.8214C31.8293 14.4723 31.8293 15.5276 31.1785 16.1784C30.5276 16.8293 29.4723 16.8293 28.8214 16.1784L21.6666 9.02361V28.3333C21.6666 29.2537 20.9204 29.9999 20 29.9999C19.0795 29.9999 18.3333 29.2537 18.3333 28.3333V9.02361L11.1785 16.1784C10.5276 16.8293 9.47232 16.8293 8.82145 16.1784C8.17057 15.5276 8.17057 14.4723 8.82145 13.8214L18.8214 3.82141ZM6.66663 34.9999C6.66663 34.0794 7.41282 33.3333 8.33329 33.3333H31.6666C32.5871 33.3333 33.3333 34.0794 33.3333 34.9999C33.3333 35.9204 32.5871 36.6666 31.6666 36.6666H8.33329C7.41282 36.6666 6.66663 35.9204 6.66663 34.9999Z"
                :fill="'#3F55EE'"
              />
            </svg>
            <h1 class="body-bold-base mt-1">
              {{ $t('message.pages.funnel.addVideo.uploadNewVideo') }}
            </h1>
            <span class="body-regular-small neutral-40-light--text text-center">
              {{ $t('message.pages.funnel.addVideo.chooseFromComputer') }}
            </span>

            <base-btn
              type="secondary"
              class="mt-4"
              @click="selectedImportVideo"
            >
              {{ $t('message.pages.funnel.addVideo.importVideo') }}</base-btn
            >
          </div>
          <div
            class="container-card-options"
            :class="{ 'w-full': isMobileBreakpoint }"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="41"
              height="40"
              viewBox="0 0 41 40"
              fill="none"
            >
              <path
                d="M27.1667 5L33.8334 11.6667L27.1667 18.3333"
                stroke="#3F55EE"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M33.8334 11.6667H7.16669"
                stroke="#3F55EE"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M13.8334 35.0001L7.16669 28.3334L13.8334 21.6667"
                stroke="#3F55EE"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.16669 28.3333H33.8334"
                stroke="#3F55EE"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <h1 class="body-bold-base mt-1">
              {{ $t('message.pages.funnel.addVideo.chooseFromLibrary') }}
            </h1>
            <span class="body-regular-small neutral-40-light--text text-center">
              {{
                $t('message.pages.funnel.addVideo.chooseFromLibraryDescription')
              }}
            </span>

            <base-btn type="primary" class="mt-4" @click="selectedLibrary">
              {{ $t('message.pages.funnel.addVideo.viewLibrary') }}</base-btn
            >
          </div>
        </div>
      </v-card>
    </v-dialog>
    <library-videos-destiny :funnelFolderId="funnelFolderId" />
    <library-videos :videos="videos" />
    <import-videos :uppyConfig="uppy" />
    <upload-list
      v-if="uploadFiles.length"
      :files="uploadFiles"
      :handleCancel="handleCancel"
      :percent="uploadProgress"
      :handlePause="handlePause"
      :paused="uploadPaused"
      :handleResume="handleResume"
    />
  </v-row>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import Vimeo from '@/utils/Vimeo'
import Dashboard from '@uppy/dashboard'
import Uppy from '@uppy/core'
import tus from '@uppy/tus'
import GoogleDrive from '@uppy/google-drive'
//import Dropbox from '@uppy/dropbox'
import Storage from '@/utils/Storage'
import Onedrive from '@uppy/onedrive'
import Url from '@uppy/url'
import {
  UPLOADER_COMPANION_URL,
  BACKUP_UPLOADER_URL,
  ENV_CONFIG,
} from '@/config/envs'
import LibraryVideosDestiny from '../../Funnel/AddVideoModais/LibraryVideosDestiny.vue'
import LibraryVideos from '../../Funnel/AddVideoModais/LibraryVideos.vue'
import ImportVideos from '../../Funnel/AddVideoModais/ImportVideos.vue'
import UploadList from '@/views/Videos/NewVideo/UploadList.vue'
import i18n from '@/translations/lang'
import hostsApi from '@/services/hostsApi'
import { v4 as uuidv4 } from 'uuid'
import videosApi from '@/services/videosApi'

export default {
  name: 'RemoveFunnel',
  components: {
    LibraryVideosDestiny,
    LibraryVideos,
    ImportVideos,
    UploadList,
  },
  props: {
    funnelFolderId: {
      type: String,
    },
  },
  data: () => ({
    open: false,
    isFetching: false,
    countVideos: 0,
    onSelectCallback: null,
    uploadPaused: false,
    uploadProgress: 0,
    uploadOpened: false,
    uploadFiles: [],
    uppyUpdated: 0,
    removingGroups: [],
    removingGroup: {
      name: '',
      id: '',
    },
    removeText: '',
    password: '',
    showPassword: false,
    permanentConfirm: false,
    passwordError: false,
    passwordErrorMessage: '',
    apiError: null,
    videos: [],
    isFetchingPlanInfo: false,
    videoIdsGetStatus: {},
    checkVideosInterval: null,
    isCheckingVideos: false,
    maxConcurrentVideoChecks: 3,
    maxRetries: 999,
    retryAttempts: {},
  }),
  computed: {
    ...mapState('user', {
      isMobileBreakpoint: 'isMobileBreakpoint',
      isTabletBreakpoint: 'isTabletBreakpoint',
    }),
    uppy() {
      this.uppyUpdated
      const objTus = this.handleTusObject()
      if (!this.isChrome() || this.isMobile()) {
        objTus.resume = false
        objTus.parallelUploads = 1
      }
      let objCompanion = this.handleCompanionObj()
      const instanceUppy = new Uppy({
        autoProceed: true,
        allowMultipleUploads: true,
        restrictions: {
          allowedFileTypes: ['video/*', '.ts'],
        },
        locale: this.uppyLocale,
      })
        .use(tus, objTus)
        .use(Dashboard)
        .use(Vimeo, { ...objCompanion, id: 'Vimeo' })
        .use(Url, { ...objCompanion, id: 'url' })
        .use(GoogleDrive, { ...objCompanion, id: 'google-drive' })
        //.use(Dropbox, { ...objCompanion, id: 'dropbox' }) // temporarily disabling Dropbox integration... waiting for the project to update Uppy and Companion to the latest versions
        .use(Onedrive, { ...objCompanion, id: 'onedrive' })
      return instanceUppy
    },
  },
  updated() {
    this.$root.$off('manual-drop')
    this.$root.$on('manual-drop', (data) => {
      const selectedItem = data && data.selectedItem ? data.selectedItem : data
      this.handleVideoSelected(selectedItem)
    })
  },
  mounted() {
    // Remove any existing listeners first
    this.$root.$off('openAddVideoDestinyFunnel')
    this.$root.$off('close-modal')
    // this.$root.$off('manual-drop')

    // Register listeners
    this.$root.$on('openAddVideoDestinyFunnel', ({ onSelect }) => {
      this.open = true
      this.onSelectCallback = onSelect
    })

    this.$root.$on('close-modal', () => {
      this.handleClose()
    })

    // this.$root.$on('manual-drop', (data) => {
    //   const selectedItem = data && data.selectedItem ? data.selectedItem : data
    //   this.handleVideoSelected(selectedItem)
    // })

    this.setUppyEvents()
  },
  beforeDestroy() {
    if (this.checkVideosInterval) {
      clearInterval(this.checkVideosInterval)
    }
    this.$root.$off('openAddVideoDestinyFunnel')
    this.$root.$off('close-modal')
    this.$root.$off('manual-drop')
    this.$root.$off('openLibraryVideo')
    this.$root.$off('openLibraryVideoDestiny')
    this.$root.$off('openImportVideo')
    this.showCrispButton()
    this.setUppyEventsOff()
  },
  methods: {
    ...mapActions('session', ['signInUser']),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    async removeVideo() {
      this.isDeleting = true
      this.$root.$emit('removeVideoFunnel')
      this.isDeleting = false
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    },
    handlePause() {
      this.uploadPaused = true
      this.uppy.pauseAll()
      this.uploadFiles = this.uppy.getFiles()
    },
    handleResume() {
      this.uploadPaused = false
      this.uppy.resumeAll()
      this.uploadFiles = this.uppy.getFiles()
    },
    handleCancel() {
      this.uppy.cancelAll()
      this.uploadFiles = this.uppy.getFiles()
    },
    handleOpenAddVideoDestiny() {
      this.$root.$emit('openAddVideoDestinyFunnel', this.funnelFolderId)
    },
    handleOpenAddVideo() {
      this.$root.$emit('openAddVideo')
    },
    isChrome() {
      return !!window.chrome
    },
    handleTusObject() {
      let uploaderUrl = `${BACKUP_UPLOADER_URL}/files/`
      if (ENV_CONFIG !== 'production') {
        uploaderUrl = `${BACKUP_UPLOADER_URL}:8443/files/`
      }
      const storageUrl = Storage.getItem('uploaderUrlv3')
      if (storageUrl) {
        uploaderUrl = `${storageUrl}/files/`
        if (ENV_CONFIG !== 'production') {
          uploaderUrl = `${storageUrl}:8443/files/`
        }
      }
      let objTus = {
        id: 'tus',
        endpoint: uploaderUrl,
        resume: false,
        retryDelays: [0, 1000],
        parallelUploads: 5,
        limit: 2,
      }
      if (!this.isChrome() || this.isMobile()) {
        objTus.resume = false
        objTus.parallelUploads = 1
      }
      return objTus
    },
    handleCompanionObj() {
      let companionUrl = `${UPLOADER_COMPANION_URL}:3020`
      if (ENV_CONFIG !== 'production') {
        companionUrl = `${UPLOADER_COMPANION_URL}:3021`
      }
      let objCompanion = {
        id: 'companion',
        target: Dashboard,
        companionUrl: companionUrl,
      }
      return objCompanion
    },
    selectedLibrary() {
      this.$root.$emit('openLibraryVideo')
    },
    selectedLibraryFromFolder() {
      if (!this.funnelFolderId) {
        console.warn(
          'funnelFolderId não está disponível, usando biblioteca geral'
        )
        this.selectedLibrary()
        return
      }
      this.$root.$emit('openLibraryVideoDestiny', this.funnelFolderId)
    },
    selectedImportVideo() {
      this.$root.$emit('openImportVideoModal')
    },
    resetState() {
      this.passwordError = false
      this.passwordErrorMessage = ''
      this.showCrispButton()
    },
    async validatePassword() {
      this.passwordError = false
      this.passwordErrorMessage = ''
      try {
        await this.signInUser({
          username: this.$store.getters['session/userAttributes'].email,
          password: this.password,
        })
        return true
      } catch (error) {
        this.passwordError = true
        this.passwordErrorMessage = this.$t(
          'message.pages.drm.modal.removeGroup.inputPasswordInvalid'
        )
        return false
      }
    },

    handleClose() {
      this.open = false
      this.removeText = ''
      this.password = ''
      this.permanentConfirm = false
      this.showPassword = false
      this.showCrispButton()
      this.$root.$emit('activeWheel')
    },
    hideCrispButton() {
      const crispButton = document.querySelector('.crisp-client')
      if (crispButton && this.isMobileBreakpoint) {
        crispButton.style.setProperty('display', 'none', 'important')
      }
    },
    showCrispButton() {
      const crispButton = document.querySelector('.crisp-client')
      if (crispButton) {
        crispButton.style.removeProperty('display')
      }
    },
    handleVideoSelected(video) {
      // Ensure we have all necessary video data
      const videoData = {
        id: video.id,
        video_external_id: video.video_external_id || video.id,
        preview: video.preview || '',
        title: video.title || video.name,
        status: video.status,
        folder_id: video.folder_id,
      }

      // Call the callback if exists
      if (this.onSelectCallback) {
        this.onSelectCallback(videoData)
      }

      // Emit event for other components that might need this info
      this.$root.$emit('video-selected', videoData)

      // Close the modal
      this.open = false
      this.onSelectCallback = null

      // Show success message
      // this.UPDATE_GLOBAL_SNACKBAR({
      //   open: true,
      //   text: this.$t('message.videoSelected'),
      //   type: 'success',
      // })
    },
    setUppyEventsOff() {
      this.uppy.off('file-added')
      this.uppy.off('upload-success')
      this.uppy.off('progress')
      this.uppy.off('restriction-failed')
      this.uppy.off('back-online')
      this.uppy.off('upload-error')
    },

    setUppyEvents() {
      // eslint-disable-next-line no-unused-vars
      this.uppy.on('upload-error', async (file, error, response) => {
        try {
          let err = error.toString()
          if (err.match('reached the maximum allowed')) {
            this.$root.$emit('onStorageSizeMax')
            this.$root.$emit('importUploadError')
            this.$root.$emit('forcePauseUploadList')
            if (!this.isFetchingPlanInfo) {
              const _this = this
              this.$root.$emit('fixUserLimit', true)
              this.isFetchingPlanInfo = true
              this.$root.$on('loadedUserLimitToUppy', () => {
                const type = err.includes('storage') ? 'storage' : 'traffic'
                _this.isFetchingPlanInfo = false

                if (_this.planInfo.subscription.status !== 'trialing') {
                  _this.$root.$emit('usageLimitModal', {
                    open: true,
                    type,
                    storagePlan: _this.planInfo?.limit?.storage_plan,
                  })
                } else if (_this.planInfo.subscription.status === 'trialing') {
                  _this.$root.$emit('ModalResetBillingCycle')
                }
              })
            }
          } else if (
            err.match('no space left') ||
            err.match('endpoint might be blocked')
          ) {
            this.swapUploadServer()
          }
        } catch (e) {
          this.UPDATE_GLOBAL_SNACKBAR({ open: true, text: `${e}` })
        }
      })

      this.uppy.on('file-added', (file) => {
        let storageKeys = Storage.getStorageKeys()
        for (let key of storageKeys) {
          if (key[0].includes('tus::tus-uppy')) {
            Storage.removeItem(key[0])
          }
        }
        const userId = this.$store.getters['session/userSub']
        const refreshToken = this.$store.state.user.refreshToken
        const authorization = 'Bearer ' + Storage.getItem('accessToken')
        const videoId = uuidv4()

        // Emitir o evento de upload iniciado
        this.$root.$emit('video-upload-started')

        // Criar o objeto de vídeo imediatamente quando o arquivo é adicionado
        const videoFormat = {
          title: file.name,
          id: videoId,
          status: 'DRAFT',
          folder_id: this.funnelFolderId || null,
          updated_at: new Date().toISOString(),
        }

        // Adicionar ao status check queue imediatamente
        this.videoIdsGetStatus[videoId] = videoFormat.status

        // Iniciar a verificação de status se ainda não estiver rodando
        if (!this.checkVideosInterval) {
          this.checkVideosInterval = setInterval(() => this.statusCheck(), 5000)
        }

        this.uppy.setFileMeta(file.id, {
          video_id: videoId,
          folder_id: this.funnelFolderId || null,
          user_id: userId,
          refresh_token: refreshToken,
          authorization: authorization,
        })
        this.uploadFiles = this.uppy.getFiles()

        // Emitir o evento de vídeo selecionado imediatamente para mostrar o loading
        this.$root.$emit('video-selected', {
          ...videoFormat,
          status: 'CONVERTING',
        })
      })

      this.uppy.on('upload-success', (file) => {
        this.$root.$emit('fixUserLimit')
        const videoFormat = {
          title: file.name,
          id: file.meta.video_id,
          status: 'DRAFT',
          folder_id: file.meta.folder_id,
          updated_at: new Date().toISOString(),
        }
        this.uploadFiles = this.uppy.getFiles()

        let storagedVideosArray = Storage.getItem(
          `panda-queue-${this.$store.state.user.userInfo.sub}`
        )
        if (!storagedVideosArray) {
          Storage.setItem(
            `panda-queue-${this.$store.state.user.userInfo.sub}`,
            [videoFormat]
          )
        } else {
          storagedVideosArray.push(videoFormat)
          Storage.setItem(
            `panda-queue-${this.$store.state.user.userInfo.sub}`,
            storagedVideosArray
          )
        }
      })

      this.uppy.on('progress', (progress) => {
        this.uploadProgress = progress
        this.uploadFiles = this.uppy.getFiles()
      })

      this.uppy.on('restriction-failed', (file) => {
        if (file.extension === 'pdf') {
          this.UPDATE_GLOBAL_SNACKBAR({
            open: true,
            text: i18n.t('message.fileExtensionError'),
          })
        }
      })

      this.uppy.on('back-online', () => {
        this.uppy.retryAll()
      })
    },

    async swapUploadServer() {
      try {
        const ret = await hostsApi.getHosts()
        let hostsArray = []
        for (let hostArea in ret.data.hosts) {
          for (let i = 0; i < hostArea.length; i++) {
            let host = ret.data.hosts[hostArea][i]
            if (host) {
              hostsArray.push(host)
            }
          }
        }
        const randomHost =
          hostsArray[Math.floor(Math.random() * hostsArray.length)]
        Storage.setItem(
          'uploaderUrlv3',
          `https://${randomHost}.pandavideo.com.br`
        )
        setTimeout(() => {
          this.uppyUpdated++
        }, 300)
      } catch (e) {
        Storage.setItem('uploaderUrlv3', BACKUP_UPLOADER_URL)
        this.uppyUpdated++
        console.error(e)
      }
      this.uppyUpdated++
    },

    async checkVideo(video) {
      try {
        if (!video.id) return

        // Initialize retry count if not exists
        if (!this.retryAttempts[video.id]) {
          this.retryAttempts[video.id] = 0
        }

        // Check if max retries reached
        if (this.retryAttempts[video.id] >= this.maxRetries) {
          console.error(`Max retries reached for video ${video.id}`)
          delete this.videoIdsGetStatus[video.id]
          delete this.retryAttempts[video.id]
          return
        }

        console.log(
          `Checking video ${video.id} - Attempt ${
            this.retryAttempts[video.id] + 1
          } of ${this.maxRetries} (interval: 5s)`
        )

        const { data: incomingVideo } = await videosApi.getAVideo(video.id)

        // Reset retry count on successful request
        this.retryAttempts[video.id] = 0

        // Se o vídeo foi encontrado na API, podemos usá-lo
        if (incomingVideo) {
          // Remove from status check queue
          delete this.videoIdsGetStatus[video.id]
          delete this.retryAttempts[video.id]

          // Clear the interval if no more videos to check
          if (
            Object.keys(this.videoIdsGetStatus).length === 0 &&
            this.checkVideosInterval
          ) {
            clearInterval(this.checkVideosInterval)
            this.checkVideosInterval = null
          }

          // Call handleVideoSelected with the video data
          this.handleVideoSelected(incomingVideo)
        }
      } catch (e) {
        console.error('Error checking video', video.id, e)

        // Increment retry count
        this.retryAttempts[video.id]++

        // If it's a 404, we'll try again in the next interval
        if (e.response && e.response.status === 404) {
          console.log(
            `Video ${video.id} not found yet, attempt ${
              this.retryAttempts[video.id]
            } of ${this.maxRetries}`
          )
          return
        }

        // For other errors, remove from queue after max retries
        if (this.retryAttempts[video.id] >= this.maxRetries) {
          delete this.videoIdsGetStatus[video.id]
          delete this.retryAttempts[video.id]
        }
      }
    },

    async statusCheck() {
      if (this.isCheckingVideos) return
      this.isCheckingVideos = true

      try {
        let toBeCheckedVideos = Object.keys(this.videoIdsGetStatus).map(
          (id) => ({
            id,
            status: this.videoIdsGetStatus[id],
          })
        )

        if (toBeCheckedVideos.length < 1) {
          if (this.checkVideosInterval) {
            clearInterval(this.checkVideosInterval)
            this.checkVideosInterval = null
          }
          return
        }

        const videoQueue = [...toBeCheckedVideos]
        const getNextVideo = () => videoQueue.shift()

        const pool = new Array(this.maxConcurrentVideoChecks)
          .fill(null)
          .map(async () => {
            let current
            while ((current = getNextVideo())) {
              await this.checkVideo(current)
            }
          })

        await Promise.all(pool)
      } finally {
        this.isCheckingVideos = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.w-full {
  width: 100%;
}
.container-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
::v-deep .v-toolbar {
  height: 90px !important;
}

::v-deep .v-toolbar__content {
  padding: 0 !important;
  align-items: flex-start !important;
}

.input::v-deep {
  label {
    left: -10px !important;
  }

  input::placeholder {
    font-size: 12px !important;
  }
}

::v-deep .v-input__append-inner {
  margin: auto !important;
}

.card-actions {
  border-top: 1px solid var(--v-neutral-95-lightest-base) !important;
}

.mobile-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  .base-button {
    width: 50%;
  }
}
.container-card-options {
  display: flex;
  padding: 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  width: 50%;
  background: varFigma(neutral-99);
}
</style>
